// Lazy load apps

document.addEventListener('scroll', () => {
  // Gorgias lazy load
  loadOnScroll('https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=10976', 'gorgias-chat-widget-install-v2');
  loadOnScroll('https://static.rechargecdn.com/assets/js/widget.min.js?shop=betterrhodes.myshopify.com', 'recharge-loader');
});

const loadOnScroll = (src, id) => {
  const body = document.querySelector('body');
  if (!document.querySelector('#' + id)) {
    const script = document.createElement('script');
    script.src = src;
    script.setAttribute('id', id);
    body.append(script);
  }
};
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href="https://www.betterrhodes.com/collections/society-de-la-rassi"]').forEach(function(el) {
    
    // Replace <a> with its inner text (whatever it is)
    el.replaceWith(document.createTextNode(el.textContent));
    
  });
});
// Trim urls like ?pr_prod_strat=...
(function () {
  const url = new URL(window.location.href);

  // Check if any Shopify tracking params exist
  const hasTrackingParams = [...url.searchParams.keys()].some(param => param.startsWith('pr_'));

  if (hasTrackingParams) {
    // Remove ALL query params (clean URL)
    const cleanURL = url.origin + url.pathname;
    window.history.replaceState({}, document.title, cleanURL);
  }
})();
// for bogo tag
// document.addEventListener("DOMContentLoaded", function () {
//   const bogo = document.querySelector(".bogo-offer");

//   function toggleBOGO() {
//     const selected = document.querySelector('.variant-input input:checked');

//     if (!selected) return;

//     const value = selected.value;

//     if (value === 'Bottle') {
//       bogo.style.display = 'block';
//     } else {
//       bogo.style.display = 'none';
//     }
//   }

//   // Initial check
//   toggleBOGO();

//   // Listen to variant change
//   document.querySelectorAll('.variant-input input').forEach(el => {
//     el.addEventListener('change', toggleBOGO);
//   });
  
// });


$(document).ready(function () {
  const bogo = $(".bogo-offer");

  function toggleBOGO() {
    const value = $('.variant-input input:checked').val()
               || $('.variant-input input:first').val(); // fallback
    bogo.toggle(value === 'Bottle');
  }

  $('.variant-input input').on('change', toggleBOGO);
  toggleBOGO();
});

// come to first place luminara napa collection product product
(function() {
  // Only run on the better-for-you-bundles collection page
  if (!window.location.pathname.includes('better-for-you-bundles')) return;

  document.addEventListener('DOMContentLoaded', function() {
    var grid = document.querySelector('.new-grid.product-grid, .collection-grid, [data-scroll-to]');
    if (!grid) return;

    // Find Luminara product by handle
    var luminara = grid.querySelector('[data-product-handle*="luminara"]');
    if (!luminara || grid.firstElementChild === luminara) return;

    // Move to first position
    grid.insertBefore(luminara, grid.firstElementChild);
  });
})();


